import { render, staticRenderFns } from "./profile-view.html?vue&type=template&id=444e7675&scoped=true&external"
import script from "./profile-view.js?vue&type=script&lang=js&external"
export * from "./profile-view.js?vue&type=script&lang=js&external"
import style0 from "./profile-view.scss?vue&type=style&index=0&id=444e7675&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e7675",
  null
  
)

export default component.exports